export class UserModel {
  id: number;
  app_hotel_id: number;
  hotel_name: string;
  app_hotels: string;
  hotel_names: string;
  email: string;
  hash: string;
  name: string;
  last_name: string;
  job_title: string;
  language_code: string;
  mobile_phone: string;
  cc_email_address: string;
  role: string;
  permissions: string;
  image_url: string | ArrayBuffer;
  guest_visible: boolean;
  department_name: string;
  department_id: number;
  sub_department: string;
  available_for_chat: boolean;
  see_all_departments_for_chat: boolean;

  constructor(id: number = 0,
              app_hotel_id: number = 0,
              hotel_name: string = '',
              app_hotels: string = '',
              hotel_names: string = '',
              email: string = '',
              hash: string = '',
              name: string = '',
              last_name: string = '',
              job_title: string = '',
              language_code: string = '',
              mobile_phone: string = '',
              cc_email_address: string = '',
              role: string = '',
              permissions: string = '',
              image_url: string = '',
              guest_visible: boolean = true,
              department_name: string = '',
              department_id: number = 0,
              sub_department: string = '',
              available_for_chat: boolean = true,
              see_all_departments_for_chat: boolean = true,
  ) {
    this.id = id;
    this.app_hotel_id = app_hotel_id;
    this.hotel_name = hotel_name;
    this.app_hotels = app_hotels;
    this.hotel_names = hotel_names;
    this.email = email;
    this.hash = hash;
    this.name = name;
    this.last_name = last_name;
    this.job_title = job_title;
    this.language_code = language_code;
    this.mobile_phone = mobile_phone;
    this.cc_email_address = cc_email_address;
    this.role = role;
    this.permissions = permissions;
    this.image_url = image_url;
    this.guest_visible = guest_visible;
    this.department_name = department_name;
    this.department_id = department_id;
    this.sub_department = sub_department;
    this.available_for_chat = available_for_chat;
    this.see_all_departments_for_chat = see_all_departments_for_chat;
  }
}
